import { type IMsalContext } from "@azure/msal-react";
import { readEnv } from "@repo/helpers";
import { B2CPolicies, type B2CPolicy, LocalStorageKeys } from "@repo/logic";
import { navigate } from "gatsby";
import { isEmpty } from "lodash";
import { LoginButtonType } from "./loginEnums";

export const REDIRECT_URI_BANKID_LOGIN = `/bank-id/login`;

export const loginErrorToText: Record<string, string> = {
    server_error: "Chyba serveru",
};

export const journeyToPolicyName = (journey: LoginButtonType): B2CPolicy => {
    // The static GATSBY_B2C_SIGNUP_SIGNIN_POLICY override and the LocalAccount MFA / V2
    // registration flags are all resolved entirely inside B2CPolicies.DirectLogin() — see there.
    const mapTable: Record<LoginButtonType, B2CPolicy> = {
        [LoginButtonType.BankId]: B2CPolicies.BankIdLogin(),
        [LoginButtonType.LocalLogin]: B2CPolicies.DirectLogin(),
        [LoginButtonType.LocalRegistration]: B2CPolicies.DirectRegistration(),
    };
    return mapTable[journey];
};

export const getBankIdRedirectUri = (): string => {
    if (!isEmpty(readEnv("GATSBY_BANK_ID_CLIENT_REDIRECT_URI"))) {
        return readEnv("GATSBY_BANK_ID_CLIENT_REDIRECT_URI")!;
    }

    return `${window.location.origin}${REDIRECT_URI_BANKID_LOGIN}`;
};

export const loginRedirect = async (msal: IMsalContext, journey: LoginButtonType, prefilledUsername?: string) => {
    if (journey === LoginButtonType.LocalRegistration) {
        navigate("/nova-registrace/", {
            state: { prefilledUsername },
        });
        return;
    }

    const domain = readEnv("GATSBY_B2C_DOMAIN")!;
    const tenantId = readEnv("GATSBY_B2C_TENANT_ID")!;
    const policy = journeyToPolicyName(journey);
    const authority = `https://${domain}/${tenantId}/${policy}`;
    localStorage.setItem(LocalStorageKeys.LAST_USED_AUTHORITY, authority);

    await msal.instance.loginRedirect({
        scopes: ["openid", readEnv("GATSBY_B2C_API_SCOPE") || ""],
        authority,
        loginHint:
            [LoginButtonType.LocalLogin, LoginButtonType.LocalRegistration].includes(journey) &&
            prefilledUsername &&
            prefilledUsername.length > 0
                ? prefilledUsername
                : undefined,
    });
};
